import { createRoute,Outlet } from '@tanstack/react-router'

import { rootRoute } from '../root'

export const newsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'news',
  component: Outlet,
})
